import { Constants } from './../../common/constants';
import { ProductRatingRequest } from './../../models/product-rating-request';
import { PlatformHttpService } from './../../common/http/service/platformhttp.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductRatingService {

  constructor(private platformHttpService: PlatformHttpService) { }


  public rateProduct(request: ProductRatingRequest) {
    return this.platformHttpService.post(Constants.PRODUCT + Constants.RATING, request);
  }
}
